module.exports = __webpack_public_path__ + "static/media/pp_logo.3561c230.svg";